<div class="invoice-container">
    <div class="header">
        <h1>PRID LIB</h1>
        <div>
            <p>Invoice #: 959351007240800</p>
            <p>Created: 10-07-2024 08:00:31</p>
            <p>Status: Fully Processed</p>
        </div>
    </div>

    <div class="info-section">
        <div class="details">
            <p><strong>Sender:</strong> Elijah Davies</p>
            <p>Mobile: 5748072235</p>
            <p>Email: paul_davies70hotmail.com</p>
        </div>
        <div class="details">
            <p><strong>Receiver:</strong> Abigail Davies</p>
            <p>Mobile: 231778727262</p>
            <p>Email: paul_davies70hotmail.com</p>
        </div>
    </div>

    <!-- Table for Products -->
    <table class="product-table">
        <thead>
            <tr>
                <th>Product Name</th>
                <th>SKU</th>
                <th>Amount</th>
                <th>Qty</th>
                <th>Total</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Prid Grains Premium Parboiled Rice - 1 Bag</td>
                <td>PPR001</td>
                <td>90.00</td>
                <td>1</td>
                <td>90.00</td>
            </tr>
            <tr>
                <td>Another Product Example</td>
                <td>ABC123</td>
                <td>150.00</td>
                <td>2</td>
                <td>300.00</td>
            </tr>
            <!-- Add more records -->
        </tbody>
    </table>
</div>
